import { FormEvent, useState } from "react";
import { FeedbackApi } from "../api";

export const FeedbackWidget = () => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    await FeedbackApi.create({
      id: crypto.randomUUID(),
      text: text.trim(),
      page: window.location.pathname,
    });
    setText("");
    setSent(true);
    setTimeout(() => {
      setSent(false);
      setOpen(false);
    }, 1200);
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-4 right-4 text-xs bg-neutral-900 text-white rounded-full px-3 py-2 shadow"
      >
        Feedback
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 w-72 bg-white border rounded shadow p-3 space-y-2">
      {sent ? (
        <p className="text-sm text-neutral-500">Thanks!</p>
      ) : (
        <form onSubmit={submit} className="space-y-2">
          <textarea
            className="w-full border rounded px-2 py-1 text-sm"
            rows={3}
            placeholder="Something broken, missing, or annoying?"
            value={text}
            onChange={(e) => setText(e.target.value)}
            autoFocus
          />
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="text-xs text-neutral-400"
            >
              Cancel
            </button>
            <button className="text-xs bg-neutral-900 text-white rounded px-3 py-1">
              Send
            </button>
          </div>
        </form>
      )}
    </div>
  );
};
